import { basenameFind, getTargetProperty } from "../common.js";
const video = {
    jpath: ['video'],
    find: basenameFind,
    getProperty: getTargetProperty,
};
export default video;
//# sourceMappingURL=video.js.map